"use client";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useInView } from "framer-motion";
import Image from "next/image";
import bgImage from "../../../public/about-bg.jpg";

const LeadershipSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section
      id="leadership"
      className="relative overflow-hidden"
      aria-labelledby="leadership-heading"
    >
      {/* Background Image with overlay */}
      <div className="absolute inset-0 z-0">
        <Image
          src={bgImage}
          alt="Leadership Team Background"
          fill
          className="object-cover"
          quality={100}
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-800/80 to-gray-900/80" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-10">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h2
            id="leadership-heading"
            className="text-4xl md:text-6xl font-bold text-white mb-6"
            variants={itemVariants}
          >
            Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-300 to-sky-500">
              Leadership
            </span>{" "}
            Team
          </motion.h2>
         
        </motion.div>

        <motion.div
          className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12"
          variants={containerVariants}
        >
          {/* Left image */}
          {/* Left image */}
<div className="w-full lg:w-1/3 flex justify-center">
  <motion.div
    className="relative w-full max-w-md rounded-xl shadow-xl overflow-hidden border-2 border-white/20"
    variants={itemVariants}
  >
    <Image
      src="/Hritik.jpg"
      alt="Hritik - Founder & CEO"
      width={400}              // Adjust based on your container
      height={500}             // Let it scale properly
      className="w-full h-auto object-contain"
      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      priority
    />
  </motion.div>
</div>




          {/* Right text */}
         <div className="w-full lg:w-2/3">
  <motion.div variants={itemVariants}>
    <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
      Hritik Gupta, Ph.D.
    </h3>
    <p className="text-sky-300 font-medium mb-4 text-lg">
      Founder & Chief Executive Officer
    </p>
    <div className="h-px bg-gradient-to-r from-transparent via-sky-500 to-transparent my-6 w-full max-w-lg"></div>

    <div className="space-y-4 text-white/90 text-base md:text-lg">
      <p>
        Hritik is an entrepreneur, builder, and a problem solver with more than 14 years of experience in turning ideas into market-ready products and solutions. He uniquely bridges the gap between the strategic goals of a business and the most advanced tech implementation, acting as both a trusted advisor and a hands-on builder.
      </p>
      <p>
        His thorough knowledge of business needs, along with his expertise in AI, data science, and software engineering makes him a great partner for top-level executives (CEOs, CTOs, and CXOs). Hritik’s deep understanding of the startup environment and big corporate structures ensures that every solution is technically sound and strategically manufactured for market success.
      </p>
      <p>
        As the Founder of GenAIPulse, Hritik leads a dynamic team committed to delivering top-notch AI, SaaS, and tech products and solutions that drive digital transformation and generate measurable growth. Hritik and his team are on a mission to empower businesses through intelligent AI, SaaS and tech solutions, and turn their vision into reality.
      </p>
    </div>
  </motion.div>
</div>

        </motion.div>
      </div>
    </section>
  );
};

export default LeadershipSection;